const uikit = {
    // margins
    mt0: { marginTop: '0' },
    mt1: { marginTop: '0.1875rem' },
    mt2: { marginTop: '0.5rem' },
    mt3: { marginTop: '1rem' },
    mt4: { marginTop: '1.5rem' },
    mt5: { marginTop: '2rem' },

    ml0: { marginLeft: '0' },
    ml1: { marginLeft: '0.1875rem' },
    ml2: { marginLeft: '0.5rem' },
    ml3: { marginLeft: '1rem' },
    ml4: { marginLeft: '1.5rem' },
    ml5: { marginLeft: '2rem' },

    mr0: { marginRight: '0' },
    mr1: { marginRight: '0.1875rem' },
    mr2: { marginRight: '0.5rem' },
    mr3: { marginRight: '1rem' },
    mr4: { marginRight: '1.5rem' },
    mr5: { marginRight: '2rem' },

    mb0: { marginBottom: '0' },
    mb1: { marginBottom: '0.1875rem' },
    mb2: { marginBottom: '0.5rem' },
    mb3: { marginBottom: '1rem' },
    mb4: { marginBottom: '1.5rem' },
    mb5: { marginBottom: '2rem' },

    mt1_minus: { marginTop: '-0.1875rem' },
    mt2_minus: { marginTop: '-0.5rem' },
    mt3_minus: { marginTop: '-1rem' },
    mt4_minus: { marginTop: '-1.5rem' },
    mt5_minus: { marginTop: '-2rem' },

    mb1_minus: { marginBottom: '-0.1875rem' },
    mb2_minus: { marginBottom: '-0.5rem' },
    mb3_minus: { marginBottom: '-1rem' },
    mb4_minus: { marginBottom: '-1.5rem' },
    mb5_minus: { marginBottom: '-2rem' },

    ml1_minus: { marginLeft: '-0.1875rem' },
    ml2_minus: { marginLeft: '-0.5rem' },
    ml3_minus: { marginLeft: '-1rem' },
    ml4_minus: { marginLeft: '-1.5rem' },
    ml5_minus: { marginLeft: '-2rem' },

    mr1_minus: { marginRight: '-0.1875rem' },
    mr2_minus: { marginRight: '-0.5rem' },
    mr3_minus: { marginRight: '-1rem' },
    mr4_minus: { marginRight: '-1.5rem' },
    mr5_minus: { marginRight: '-2rem' },

    // paddings
    pt0: { paddingTop: '0' },
    pt1: { paddingTop: '0.1875rem' },
    pt2: { paddingTop: '0.5rem' },
    pt3: { paddingTop: '1rem' },
    pt4: { paddingTop: '1.5rem' },
    pt5: { paddingTop: '2rem' },

    pl0: { paddingLeft: '0' },
    pl1: { paddingLeft: '0.1875rem' },
    pl2: { paddingLeft: '0.5rem' },
    pl3: { paddingLeft: '1rem' },
    pl4: { paddingLeft: '1.5rem' },
    pl5: { paddingLeft: '2rem' },

    pr0: { paddingRight: '0' },
    pr1: { paddingRight: '0.1875rem' },
    pr2: { paddingRight: '0.5rem' },
    pr3: { paddingRight: '1rem' },
    pr4: { paddingRight: '1.5rem' },
    pr5: { paddingRight: '2rem' },

    pb0: { paddingBottom: '0' },
    pb1: { paddingBottom: '0.1875rem' },
    pb2: { paddingBottom: '0.5rem' },
    pb3: { paddingBottom: '1rem' },
    pb4: { paddingBottom: '1.5rem' },
    pb5: { paddingBottom: '2rem' },

    capitalize: { textTransform: 'capitalize' },
    lowercase: { textTransform: 'lowercase' },
    //buttons
    button: {
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.125rem',
        lineHeight: '1.3334',
        fontWeight: '500',
        padding: '1.25rem'
    },
    buttonSm: {
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        fontSize: '1rem',
        padding: '0.75rem',
        lineHeight: '1.5'
    },
    // styles
    width100: { width: '100%' },
    positionAbsolute: { position: 'absolute' },
    positionRelative: { position: 'relative' },
    pointer: { cursor: 'pointer' },

    none: { display: 'none' },
    block: { display: 'block' },
    flexRow: {
        display: 'flex',
        flexDirection: 'row'
    },
    flexColumnReverse: {
        display: 'flex',
        flexDirection: 'column-reverse'
    },
    flexRowReverse: {
        display: 'flex',
        flexDirection: 'row-reverse'
    },

    flexInline: { display: 'inline-flex' },

    flexGrow1: { flexGrow: '1' },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column'
    },
    alignItemsCenter: { alignItems: 'center' },
    alignItemsStart: { alignItems: 'flex-start' },
    alignItemsEnd: { alignItems: 'flex-end' },
    alignItemsUnset: { alignItems: 'unset' },
    justifyContentStart: { justifyContent: 'flex-start' },
    justifyContentCenter: { justifyContent: 'center' },
    justifyContentEnd: { justifyContent: 'flex-end' },
    justifyContentBetween: { justifyContent: 'space-between' },
    flexWrap: { flexWrap: 'wrap' },
    flexNoWrap: { flexWrap: 'no-wrap' },
    noWrap: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    hr: {
        opacity: '0.5',
        borderBottomWidth: '1px',
        borderStyle: 'solid',
        display: 'flex',
        height: '1px',
        marginTop: '40px',
        marginBottom: '40px'
    },
    textCenter: { textAlign: 'center' },

    medium: { fontWeight: '500' },
    regular: { fontWeight: '400' },

    input: { fontSize: '1rem' },
    h1: {
        // 82px
        fontSize: '5.125rem',
        lineHeight: '1.17',
        fontWeight: '400'
    },
    h2: {
        // 60px
        fontSize: '3.75rem',
        lineHeight: '1.16',
        fontWeight: '400'
    },
    h3: {
        // 42px
        fontSize: '2.625rem',
        lineHeight: '1.19',
        fontWeight: '500'
    },
    h4: {
        // 36px
        fontSize: '2.25rem',
        lineHeight: '1.2',
        fontWeight: '500'
    },
    h5: {
        // 28px
        fontSize: '1.75rem',
        lineHeight: '1.28'
    },
    h6: {
        // 24px
        fontSize: '1.5rem',
        lineHeight: '1.3',
        fontWeight: '400'
    },
    title: {
        // 20px
        fontSize: '1.25rem',
        lineHeight: '1.3'
    },
    subtitle: {
        // 18px
        fontSize: '1.125rem',
        lineHeight: '1.44'
    },
    text: {
        // 16px
        fontSize: '1rem',
        lineHeight: '1.5',
        fontWeight: '400'
    },
    small: {
        // 14px
        fontSize: '0.875rem',
        lineHeight: '1.4'
    },
    tiny: {
        // 12px
        fontSize: '0.75rem',
        lineHeight: '1.33'
    }
};
export default uikit;
